/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsGooglePublicAuthOptions } from './FxIdDomainSettingsGooglePublicAuthOptions';
import {
    instanceOfFxIdDomainSettingsGooglePublicAuthOptions,
    FxIdDomainSettingsGooglePublicAuthOptionsFromJSON,
    FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped,
    FxIdDomainSettingsGooglePublicAuthOptionsToJSON,
} from './FxIdDomainSettingsGooglePublicAuthOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogle
 * Настройки для Google
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogle = FxIdDomainSettingsGooglePublicAuthOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogle {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogle {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsGooglePublicAuthOptions(json)) {
        return FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsGooglePublicAuthOptions(value)) {
        return FxIdDomainSettingsGooglePublicAuthOptionsToJSON(value as FxIdDomainSettingsGooglePublicAuthOptions);
    }

    return {};
}

